// src/components/ChaletImages.tsx

"use client";

import React, { useEffect } from "react";
import Carousel from "react-gallery-carousel";
import "react-gallery-carousel/dist/index.css";
import type { ChaletImage } from "@/types/chaletData";

interface ChaletImagesProps {
  images: ChaletImage[];
}

const ChaletImages: React.FC<ChaletImagesProps> = ({ images }) => {
  useEffect(() => {}, []);

  if (!images || images.length === 0) {
    return null;
  }

  // Transform ChaletImage to the format required by Carousel
  const carouselImages = images.map((img) => ({
    src: img.src || img.thumbnail || "",
    alt: img.alt || "Chalet Image",
  }));

  return (
    <section className="section" aria-labelledby="chalet-images">
      <div className="carousel-container">
        <Carousel
          images={carouselImages}
          style={{ height: "80vh" }}
          hasThumbnails
          hasLeftButton
          hasRightButton
        />
      </div>
    </section>
  );
};

export default ChaletImages;
